module.exports = __webpack_public_path__ + "static/media/13-d-calendar.caa63337.jpg";